import script from "./games.vue?vue&type=script&setup=true&lang=ts"
export * from "./games.vue?vue&type=script&setup=true&lang=ts"

import "./games.vue?vue&type=style&index=0&id=15d5da20&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15d5da20"]])

export default __exports__